import { Component } from '@angular/core';

@Component({
  selector: 'app-appliance-icon',
  templateUrl: './appliance-icon.component.svg',
  styleUrls: ['./appliance-icon.component.scss']
})
export class ApplianceIconComponent
{

  constructor() { }

}
